import { SelfServeContext, SelfServeNodeLevel } from "../types";

export const buildNodeLevelPropName = (
  level: SelfServeNodeLevel
): keyof SelfServeContext => {
  return `level${level}Node` as keyof SelfServeContext;
};
